import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';
import { PartRegion } from '@/features/storefront/parts/PartRegion';

/**
 * A skincare product page: the photograph and the buy column, side by side
 * and roughly equal, with a wide gutter between them.
 *
 * The buy column sticks beside the photograph on a wide screen - it is short
 * by design (see `productPage.ts`), so it always fits under the masthead - and
 * on a phone the two simply stack. The breadcrumb above and the suggestions
 * below are drawn by the page itself at its own width.
 */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="grid gap-10 py-10 lg:grid-cols-2 lg:gap-16">
    <PartRegion name="gallery" className="min-w-0" />
    <PartRegion name="main" className="min-w-0 lg:sticky lg:top-40 lg:self-start" />
  </StorefrontContainer>
);
